import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function MediaQueryXs(props) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only('xs'));
  if(matches) {
    return props.content
  } else {
    return null
  }
}

export default MediaQueryXs;